"use client"
import { Phone, Clock } from "lucide-react"

export default function WorkroomPhoneNumbers() {
  const workroomData = [
    { location: "Atlanta Workroom", phone: "(404) 555-0101", hours: "Mon-Fri 8AM-6PM", manager: "John Smith" },
    { location: "Birmingham Workroom", phone: "(205) 555-0102", hours: "Mon-Fri 8AM-5PM", manager: "Sarah Johnson" },
    { location: "Nashville Workroom", phone: "(615) 555-0103", hours: "Mon-Fri 7AM-5PM", manager: "Mike Davis" },
    { location: "Memphis Workroom", phone: "(901) 555-0104", hours: "Mon-Fri 8AM-6PM", manager: "Lisa Wilson" },
    { location: "Huntsville Workroom", phone: "(256) 555-0105", hours: "Mon-Fri 8AM-5PM", manager: "David Brown" },
  ]

  return (
    <div className="p-4 lg:p-6">
      <div className="max-w-6xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl lg:text-3xl font-bold text-[#004261] mb-2 uppercase tracking-wide">
            Workroom Phone Numbers
          </h1>
          <div className="w-16 h-1 bg-[#00CCFE] mb-4"></div>
          <p className="text-gray-600">Contact information for all regional workroom locations</p>
        </div>

        <div className="bg-white rounded-lg shadow-lg border border-gray-200 overflow-hidden">
          <div className="bg-[#004261] px-6 py-4">
            <h2 className="text-white font-bold text-lg uppercase tracking-wide">Regional Workrooms</h2>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-6 py-4 text-left text-xs font-bold text-[#004261] uppercase tracking-wider">
                    Location
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-bold text-[#004261] uppercase tracking-wider">
                    Phone Number
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-bold text-[#004261] uppercase tracking-wider">
                    Hours
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-bold text-[#004261] uppercase tracking-wider">
                    Manager
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {workroomData.map((workroom, index) => (
                  <tr
                    key={index}
                    className={`${index % 2 === 0 ? "bg-white" : "bg-gray-50"} hover:bg-blue-50 transition-colors`}
                  >
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <div className="h-8 w-8 bg-[#00CCFE] rounded-full flex items-center justify-center mr-3">
                          <Phone className="h-4 w-4 text-white" />
                        </div>
                        <div className="text-sm font-medium text-gray-900">{workroom.location}</div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <a
                        href={`tel:${workroom.phone}`}
                        className="text-[#00CCFE] hover:text-[#004261] font-medium text-sm hover:underline transition-colors"
                      >
                        {workroom.phone}
                      </a>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center text-sm text-gray-600">
                        <Clock className="h-4 w-4 text-[#00CCFE] mr-2" />
                        {workroom.hours}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900 font-medium">
                      {workroom.manager}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-6 bg-blue-50 border border-[#00CCFE] rounded-lg p-4">
          <div className="flex items-start">
            <Phone className="h-5 w-5 text-[#00CCFE] mt-0.5 mr-3 flex-shrink-0" />
            <div>
              <h3 className="text-sm font-medium text-[#004261] mb-1">Need Help?</h3>
              <p className="text-sm text-gray-600">
                If you need assistance reaching a specific workroom, please contact our main office at{" "}
                <a href="tel:(800) 555-0100" className="text-[#00CCFE] hover:underline font-medium">
                  (800) 555-0100
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
